import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { OrganizationIntegrationService } from '@core/services/entities/organization-integration.service';
import { OrganizationIntegrationResponseDto } from '@domain/organization-integration/dtos/organization-integration.response.dto';
import { CreateOrganizationIntegrationRequestDto } from '@domain/organization-integration/dtos/create-organization-integration.request.dto';
import { ListOrganizationIntegrationRequestDto } from '@domain/organization-integration/dtos/list-organization-integration.request.dto';
import { UpdateOrganizationIntegrationRequestDto } from '@domain/organization-integration/dtos/update-organization-integration.request.dto';
import { OrganizationIntegrationRepository } from '@domain/organization-integration/repositories/organization-integration.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationIntegrationRepositoryService implements OrganizationIntegrationRepository {
  constructor(private organizationIntegrationService: OrganizationIntegrationService) {}

  create(
    request: CreateOrganizationIntegrationRequestDto,
  ): Observable<ApiResponse<OrganizationIntegrationResponseDto>> {
    return this.organizationIntegrationService.create(request);
  }

  update(
    request: UpdateOrganizationIntegrationRequestDto,
  ): Observable<ApiResponse<OrganizationIntegrationResponseDto>> {
    return this.organizationIntegrationService.update(request);
  }

  show(request: RefId): Observable<ApiResponse<OrganizationIntegrationResponseDto>> {
    return this.organizationIntegrationService.show(request);
  }

  list(
    request: ListOrganizationIntegrationRequestDto,
  ): Observable<ApiResponse<PageableResponse<OrganizationIntegrationResponseDto>>> {
    return this.organizationIntegrationService.list(request);
  }
}
